<template>
  <BFormCheckbox :name="`checkbox-${ data.value }`"
                 :value="data.value"
                 @change="$emit('change')">
    {{ data.text }}
  </BFormCheckbox>
</template>

<script>
  import { BFormCheckbox } from 'bootstrap-vue';

  export default {
    name: 'Setting',
    components: {
      BFormCheckbox,
    },
    props: {
      data: {
        type: Object,
        required: true,
      },
    },
    emits: ['change'],
  };
</script>
